import {Component, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {AngularFireAuth} from '@angular/fire/auth';
import {LoadingDialogComponent} from '../../dialogs/loading-dialog/loading-dialog.component';
import {WindowService} from '../../services/window.service';
import {AngularFirestore} from '@angular/fire/firestore';
import { MatDialog } from '@angular/material/dialog';
import {LocalConstants} from '../../beans/LocalConstants';
import * as firebase from 'firebase';
import {Router} from '@angular/router';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

    codeSent = false;
    windowRef: any;
    name: string;
    companyName: string;
    phoneNumber: string;
    phoneNumberCode: string;
    email: string;
    role: string;

    constructor(private win: WindowService, public db: AngularFirestore, public dialog: MatDialog, public toastService: ToastrService, public _auth: AngularFireAuth, public router: Router) {
    }

    ngOnInit() {

        this.windowRef = this.win.windowRef;


        this.windowRef.recaptchaVerifier = new firebase.default.auth.RecaptchaVerifier('recaptcha-container', {
            'size': 'invisible',
            'callback': function (response) {
                // console.log(response);
            }
        });
        this.windowRef.recaptchaVerifier.render();


    }

    private showError(error: string, title: string) {
        this.toastService.error(error, title);
    }


    sendOTP(dialogRef) {
        const appVerifier = this.windowRef.recaptchaVerifier;

        this._auth.signInWithPhoneNumber('+' + this.phoneNumberCode + this.phoneNumber, appVerifier)
            .then((confirmationResult) => {
                dialogRef.close();
                this.codeSent = true;
                this.windowRef.confirmationResult = confirmationResult;
            }).catch((error) => {
                dialogRef.close();
                // console.log(error);
                this.showError(error, 'Error');
            }
        );


    }

    verifyLoginCode(verificationCode) {
        if (verificationCode.length !== 6) {
            this.showError('Kindly Enter a Valid 6 digit OTP', 'Invalid OTP');
            return;
        }
        const dialogRef = this.dialog.open(LoadingDialogComponent, {
            panelClass: "my-panel",
        });
        this.windowRef.confirmationResult
            .confirm(verificationCode)
            .then(result => {
                dialogRef.close();

                this.createUser(result.user);


            })
            .catch(error => {
                // console.log(error, 'Incorrect code entered?'),
                dialogRef.close();
                // console.log('Error', error);
                this.showError('Kindly Enter a Valid 6 digit OTP', 'Incorrect code entered?');
            });
    }

    validateAndProceed(name: string, companyName: string, phoneNumberCode: string, phoneNumber: string, email: string, role: string, otpNode) {

        if (!name || name.trim().length <= 0) {
            this.showError('Please enter your name', 'Name Required');
            return;
        }

        if (!companyName || companyName.trim().length <= 0) {
            this.showError('Please enter your company name', 'Company Name Required');
            return;
        }

        if (!email || email.trim().length <= 0) {
            this.showError('Please enter your email address', 'Email Required');
            return;
        }

        if (!this.validateEmail(email)) {
            this.showError('Please enter a valid email address', 'Valid Email Required');
            return;
        }

        if (!phoneNumber) {
            this.showError('Please enter a valid phone number', 'Phone Number Required');
            return;
        }

        this.name = name.trim();
        this.companyName = companyName.trim();
        this.phoneNumber = phoneNumber.trim();
        this.phoneNumberCode = phoneNumberCode.trim();
        this.email = email.trim();
        this.role = role !== undefined ? role.trim() : '';

        otpNode.value = '';

        this.checkAccountInDB();

    }

    validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(email)) {
            return (true);
        }
        return (false);
    }


    checkAccountInDB() {

        const dialogRef = this.dialog.open(LoadingDialogComponent, {
            panelClass: "my-panel",
        });

        this.db.collection(LocalConstants.keysCollection, x => x.where('phoneNumber', '==', this.phoneNumber))
            .get()
            .toPromise()
            .then((result) => {

                // console.log(result.docs.length);

                if (result.docs.length > 0) {
                    dialogRef.close();
                    this.showError('Kindly login to view account details', 'Already Registered');
                    return;
                } else {
                    this.sendOTP(dialogRef);
                }

            }).catch(error => {
            dialogRef.close();
            this.showError(error.toString(), 'Error');
        });


    }

    private createUser(user: any) {

        const dialogRef = this.dialog.open(LoadingDialogComponent, {
            panelClass: "my-panel",
        });

        this.db.collection(LocalConstants.keysCollection)
            .doc(user.uid)
            .set({
                'phoneNumber': this.phoneNumber,
                'email': this.email,
                'name': this.name,
                'companyName': this.companyName,
                'role': this.role,
                'uid': user.uid,
                'phoneNumberCode': this.phoneNumberCode,
                'phoneNumberInternational': this.phoneNumberCode + this.phoneNumber,
                'creationDate': firebase.default.firestore.FieldValue.serverTimestamp(),
                'usages': 0,
                'totalUsages': 0,
                'paidUsages': 0
            })

            .then((result) => {
                dialogRef.close();
            }).catch(error => {
            dialogRef.close();
            this.showError(error.toString(), 'Error');
        });


    }
}
